export const WORKSPACE_INVITE_PATH_PREFIX = '/workspace/invite/verify/'
export const PENDING_WORKSPACE_INVITE_KEY = 'pendingWorkspaceInvite'
const INVITE_EXPIRATION_MS = 24 * 60 * 60 * 1000

export const getWorkspaceInviteTokenFromPath = (pathname) => {
  if (!pathname || !pathname.startsWith(WORKSPACE_INVITE_PATH_PREFIX)) return null
  const token = pathname.replace(WORKSPACE_INVITE_PATH_PREFIX, '').split('/')[0]
  return token || null
}

export const persistPendingWorkspaceInvite = (pathname) => {
  const token = getWorkspaceInviteTokenFromPath(pathname)
  if (!token) return null
  try {
    // eslint-disable-next-line no-undef
    localStorage.setItem(PENDING_WORKSPACE_INVITE_KEY, JSON.stringify({
      token,
      createdAt: Date.now()
    }))
  } catch (_) {}
  return token
}

const readPendingWorkspaceInvite = () => {
  try {
    // eslint-disable-next-line no-undef
    const raw = localStorage.getItem(PENDING_WORKSPACE_INVITE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (typeof parsed === 'string') return { token: parsed }
    if (parsed?.token) return parsed
    return null
  } catch (_) {
    return null
  }
}

const clearPendingWorkspaceInvite = () => {
  try {
    // eslint-disable-next-line no-undef
    localStorage.removeItem(PENDING_WORKSPACE_INVITE_KEY)
  } catch (_) {}
}

export const consumePendingWorkspaceInvite = () => {
  const pendingInvite = readPendingWorkspaceInvite()
  if (!pendingInvite?.token) {
    clearPendingWorkspaceInvite()
    return null
  }
  if (pendingInvite.createdAt && (Date.now() - pendingInvite.createdAt > INVITE_EXPIRATION_MS)) {
    clearPendingWorkspaceInvite()
    return null
  }
  clearPendingWorkspaceInvite()
  return pendingInvite.token
}
